import ApiClient from "../../../api/ApiClient";

export interface PttRequest {
  target: number;
  wgId?: number;
  targetParams: number[];
  url: string;
}

export async function sendPttRequest(request: PttRequest): Promise<void> {
  return await ApiClient().post("/ptt", request);
}
